import type { WalletExecutionErrorCode } from '@funkit/connect-core'
import type { TFunction } from 'i18next'

// Two lines on a phone. A provider that returns its whole stack should not push
// the fee summary and the CTA off the sheet.
const MAX_ERROR_DETAIL_CHARS = 160

/**
 * What the user reads for a failure core classified. Web's copy, per cause.
 *
 * A cause core could name gets that copy: it is translated and says what to do,
 * which no provider string does. Everything else falls back to the error's own
 * text — "please try again" is the one message that helps nobody, and the
 * failures that land here are the ones neither we nor the user can otherwise
 * diagnose. Truncated, since a relay error can run to paragraphs.
 */
export function executionErrorMessage(
  t: TFunction,
  code: WalletExecutionErrorCode,
  message?: string,
): string {
  switch (code) {
    case 'insufficient-gas':
      return t('withdrawCrypto.errorInsufficientGas')
    case 'switch-chain':
      return t('withdrawCrypto.errorSwitchChain')
  }
  const detail = message?.trim()
  if (!detail) {
    return t('withdrawCrypto.errorGeneric')
  }
  return detail.length > MAX_ERROR_DETAIL_CHARS
    ? `${detail.slice(0, MAX_ERROR_DETAIL_CHARS)}…`
    : detail
}
